import { apiService } from 'core/services';
import { IPostHierarchyTreeItemsOrder } from 'core/services/navigation/hierarchy.dto';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { getErrorFromService } from 'shared/utils/https';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { getUnexpectedErrorMessages } from '../../navigation.utils';
import { INavigationState } from '../../types';

export const arrangeNavigationItem = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/arrangeNavigationItem`,
  async (data: IPostHierarchyTreeItemsOrder) => {
    try {
      await apiService.hierarchy.updateHierarchyItemsOrder(data);
      notificationService.global.success('Mundo ordenado correctamente.');
    } catch (error) {
      notificationService.global.error(getErrorFromService(error, getUnexpectedErrorMessages('items', 'arrange')));
      throw error;
    }
  },
);

export const arrangeNavigationItemReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(arrangeNavigationItem.pending, state => {
      state.navigationList.loading.status = true;
    })
    .addCase(arrangeNavigationItem.rejected, state => {
      state.navigationList.loading.status = false;
    })
    .addCase(arrangeNavigationItem.fulfilled, state => {
      state.navigationList.loading.status = false;
    });
